// extracted by mini-css-extract-plugin
export default {"uploadButton":"upload-button_uploadButton__a3Mjd","button":"upload-button_button__8O9YF"};